import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';
import { API_URL as API } from '../utils/config';

const CartContext = createContext();

// Configure axios defaults for credentials
axios.defaults.withCredentials = true;

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart must be used within CartProvider');
  }
  return context;
};

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);
  const [loading, setLoading] = useState(false);
  const { token } = useAuth();

  useEffect(() => {
    fetchCart();
  }, [token]);

  const fetchCart = async () => {
    try {
      setLoading(true);
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      const response = await axios.get(`${API}/cart`, { headers, withCredentials: true });
      setCart(response.data);
    } catch (error) {
      console.error('Failed to fetch cart:', error);
    } finally {
      setLoading(false);
    }
  };

  const addToCart = async (product_id, quantity = 1, shade = null) => {
    try {
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      console.log('Adding to cart:', { product_id, quantity, shade, api: `${API}/cart` });
      const response = await axios.post(`${API}/cart`, { product_id, quantity, shade }, { headers, withCredentials: true });
      console.log('Cart response:', response.data);
      await fetchCart();
      return response.data;
    } catch (error) {
      console.error('Add to cart error details:', error.response?.data || error.message);
      throw error;
    }
  };

  const removeFromCart = async (item_id) => {
    try {
      await axios.delete(`${API}/cart/${item_id}`);
      await fetchCart();
    } catch (error) {
      console.error('Failed to remove from cart:', error);
      throw error;
    }
  };

  const clearCart = async () => {
    try {
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      await axios.delete(`${API}/cart`, { headers, withCredentials: true });
      setCart([]);
    } catch (error) {
      console.error('Failed to clear cart:', error);
      throw error;
    }
  };

  const cartCount = cart.reduce((total, item) => total + item.quantity, 0);

  return (
    <CartContext.Provider value={{ cart, cartCount, loading, addToCart, removeFromCart, clearCart, fetchCart }}>
      {children}
    </CartContext.Provider>
  );
};